import {removeAiCursor} from "./Utils.ts";
import {truncateToolMessages, truncateUserMessage} from "../../../contextManagement/messageTrucater.ts";
import {getDefaultLlmRequestRefs} from "../../../../../Globals.ts";
import {updateUserStats} from "../../../../db/users/userStats/updateUserStats.ts";
import {writeToChatHistory} from "../../../../db/chatHistory/writeToChatHistory.ts";
import {decrementMonthlyFreeMessages} from "../../../../db/users/userInfo/decrementMonthlyFreeMessages.ts";
import {generateAndAttachSummary} from "../../../contextManagement/summaryUtils.ts";

const cancelWebsocketTools = async (llmRequestRefs: any, websocketRef: any) => {
    const websocketToolNames = new Set(['deepResearch', 'gatherContext', 'createPdf', 'createDocx']);

    Object.values(llmRequestRefs.current.toolCalls).forEach((tool: any) => {
        if (websocketToolNames.has(tool.name)) {
            websocketRef.current.send(JSON.stringify({
                functionName: "toolAgent",
                args: {action: "stop", agent: tool.name}
            }));
        }
    });
}

export const handleEndTurn = async (messagesSequenceRef: any, isStoppingRef: any, dynamicStateObjRef: any, setDynamicStateObj: any, setUserObj: any, setMessages: any, updateElementInProgress: any, userObjRef: any, environment: string, vscode: any, llmRequestRefs: any, settingsObjRef: any, websocketRef: any, wasAborted: boolean, messagesRef: any) => {
    await cancelWebsocketTools(llmRequestRefs, websocketRef);

    llmRequestRefs.current.streamId = null;
    isStoppingRef.current = true;
    setDynamicStateObj({isStopping: true});

    Object.entries(dynamicStateObjRef.current.unreviewedFileTracker).forEach(([filePath, fileInfo]: [string, any]) => {
        const data: any = {filePath, operation: fileInfo.operation};
        if (fileInfo.originalFilePath) data.originalFilePath = fileInfo.originalFilePath;
        if (fileInfo.originalContents) data.originalContents = fileInfo.originalContents;

        const args = {
            functionName: "giveOriginalFileState",
            data: [data],
        };

        if (environment.includes("jetbrains")) window.jetbrainsPostMessage(JSON.stringify(args));
        else if (environment === "vscode") vscode.postMessage(args);
    });

    clearInterval(llmRequestRefs.current.intervalId);
    removeAiCursor(llmRequestRefs, setMessages);

    // Start summary generation in parallel with truncation work.
    // Must complete before DB write since the summary is attached to the AI message.
    const summaryPromise = generateAndAttachSummary(messagesRef, messagesSequenceRef, llmRequestRefs, userObjRef);

    truncateToolMessages(llmRequestRefs.current.toolMessages);
    truncateUserMessage(llmRequestRefs.current.userMessage);
    if (llmRequestRefs.current.messagesToWrite.length !== 0) {
        await Promise.all([
            summaryPromise,
            ...llmRequestRefs.current.messagesToWrite.map(async (message: { message: { content: any[] } }) => {
                if (!message.message?.content) {
                    message.message = message.message || {};
                    message.message.content = [];
                    return;
                }
            })
        ]);

        await writeToChatHistory(userObjRef.current.user, settingsObjRef.current.isIncognito, dynamicStateObjRef.current.conversationId, messagesSequenceRef, llmRequestRefs);
        updateUserStats(userObjRef.current.user, environment, vscode, {incrementMessageCount: 1}, setDynamicStateObj);
    }
    llmRequestRefs.current = getDefaultLlmRequestRefs();
    updateElementInProgress('', 'clear');
    setDynamicStateObj({canSubmit: true, isStopping: false});
    isStoppingRef.current = false;

    if (userObjRef.current.monthlyFreeMessages > 0 && !wasAborted) {
        const newRemainingMessages = userObjRef.current.monthlyFreeMessages-1;
        setUserObj({monthlyFreeMessages: newRemainingMessages});
        decrementMonthlyFreeMessages(userObjRef.current.user);

        // Show downgrade message if user just ran out of free messages
        if (newRemainingMessages === 0 && !userObjRef.current.subscriptionPlan) {
            setDynamicStateObj({visiblePopup: "downgradeMessage"});
        }
    }
};

export const handleFinishStream = async (llmRequestRefs: any, setMessages: any, updateElementInProgress: any) => {
    removeAiCursor(llmRequestRefs, setMessages);
    updateElementInProgress('stream', 'delete');
};
